import axios from 'axios';
import { z } from 'zod';
import { getApiUrl } from '~/api';
import { getAuthToken } from '~/auth';

interface CreateFunctionParams<TInputSchema extends z.ZodSchema<any>> {
  name: string;
  input: TInputSchema;
}

export const createBackgroundFunction = <
  TInputSchema extends z.ZodSchema<any>,
>({
  name,
  input,
}: CreateFunctionParams<TInputSchema>) => {
  return async (inputData: z.infer<TInputSchema>): Promise<void> => {
    input.parse(inputData);

    const url = getApiUrl(`/background/trigger/${name}`);
    const authToken = await getAuthToken();
    const result = await axios({
      url,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      data: inputData,
    });

    return result.data;
  };
};
